var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelFacebookIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FB",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.486,
    height: 15.486,
    viewBox: "0 0 15.486 15.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M15.486,7.743a7.743,7.743,0,1,0-8.953,7.649V9.981H4.567V7.743H6.533V6.037A2.732,2.732,0,0,1,9.458,3.025a11.79,11.79,0,0,1,1.733.153V5.083h-.976A1.119,1.119,0,0,0,8.953,6.292V7.745H11.1l-.343,2.238H8.952v5.409A7.745,7.745,0,0,0,15.486,7.743Z",
    transform: "translate(0 0)",
    fill: "#1877f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M155.682,105.97l.344-2.243h-2.152v-1.455a1.122,1.122,0,0,1,1.264-1.212h.978V99.153A11.813,11.813,0,0,0,154.379,99a2.738,2.738,0,0,0-2.93,3.018v1.709H149.48v2.243h1.97v5.421a7.841,7.841,0,0,0,2.425,0V105.97Z",
    transform: "translate(-144.919 -95.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelFacebookIcon);
export default __webpack_public_path__ + "static/media/channel-facebook-icon.068556cc5b3a09bf5c37fba3e28b3aa2.svg";
export { ForwardRef as ReactComponent };